import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { getMyUserQuery, getTeamMembersQuery } from '../../../queries/queries';
import { EditButton, sortList } from '../../../common/index';
import Form from './TeamMembersForm';
import ModalAddTeammember from './ModalAddTeammember';
import TeamMember from './TeamMember';
import ArrowBlack from '../../../img/arrow-black.svg';
import ImgShoppen from '../../../img/shoppen@2x.png';

const { REACT_APP_BRAND } = process.env;
function TeamMembersTable(props) {
  const { teamId } = props;
  const possessionType = JSON.parse(localStorage.getItem('POSSESSION'))?.type;
  const [editing, setEditing] = useState('');
  const [sortBy, setSortBy] = useState('firstname');
  const [sortOrder, setSortOrder] = useState(1);
  const sort = { sortBy, sortOrder, setSortBy, setSortOrder };
  const { data: userData } = useQuery(getMyUserQuery);
  const [isFirstTeammember, setIsFirstTeammember] = React.useState();
  const [moveOrdersFrom, setMoveOrdersFrom] = React.useState(null);
  var { loading: teamMembersLoading, error: teamMembersError, data: teamMembersData, refetch: refetchTeamMembers } = useQuery(getTeamMembersQuery, {
    variables: { teamId: teamId, includeNotApprovedByGuardian: true }
  })

  useEffect(() => {
    setIsFirstTeammember(teamMembersData?.teamMembers?.length === 0);
  }, [teamMembersData?.teamMembers])

  return (
    <>
      {editing === 'new' &&
        <ModalAddTeammember
          teamId={teamId}
          isFirstTeammember={isFirstTeammember}
          setIsFirstTeammember={setIsFirstTeammember}
          setEditing={setEditing}
          refetchTeamMembers={refetchTeamMembers}
        />}

      {teamMembersData?.teamMembers?.length > 0 || possessionType === 'association'
        ? <table className="superAdmin teammembers-table m-0">
          <thead className='relative'>
            <tr>
              <td>Lagmedlem/Målsman</td>
            </tr>
          </thead>
          <tbody>
            {teamMembersLoading ? 'Laddar..' : (teamMembersError) ? 'Något gick fel vid hämtning av teamet' : (
              sortList(teamMembersData.teamMembers, sort)
                .map((obj) => (
                  editing === obj._id
                    ? <Form key={obj._id} content={obj} onComplete={() => setEditing('')} />
                    : <TeamMember key={obj._id} teammember={obj} user={userData?.user} setEditing={setEditing} refetchTeamMembers={refetchTeamMembers} moveOrdersFrom={moveOrdersFrom} setMoveOrdersFrom={setMoveOrdersFrom} />
                )))}
            {/* {REACT_APP_BRAND !== 'SAENKELT' && (userData?.user?.superAdmin || possessionType === 'team') &&
              <tr>
                <td></td>
                <td>
                  <EditButton size="md" setEditing={() => setEditing('new')}>Lägg till lagmedlem</EditButton>
                </td>
              </tr>
            } */}
          </tbody>
        </table>
        : REACT_APP_BRAND !== 'SAENKELT' && teamMembersData?.teamMembers
          ? <div className="table-empty">
            <p>Klicka på 'Lägg till lagmedlem' för att lägga till dina lagmedlemmar.</p>
            <img src={ArrowBlack} alt="" />
            <EditButton size="md" setEditing={() => setEditing('new')}>Lägg till lagmedlem</EditButton>
          </div>
          : teamMembersData?.teamMembers && <div className="table-empty teammembers-table">
            <div>
              <p>Ojdå, här var det tomt!</p>
              <p>När säljarna har registrerat sig hittar du en lista med säljare här.</p>
            </div>
            <div>
              <b>Under fliken "Hem" hittar du information<br />om hur ni skapar personliga webbshoppar.</b>
            </div>
            <div>
              <img src={ImgShoppen} alt="" />
            </div>
          </div>
      }
    </>
  );
}


TeamMembersTable.propTypes = {
  //teamMembersQuery: PropTypes.object.isRequired,
  associationId: PropTypes.string.isRequired,
  teamId: PropTypes.string.isRequired,
};
export default TeamMembersTable;
/*
export default TeamMembersTable(
  graphql(getTeamMembersQuery, { name: 'teamMembersQuery' }),
)(TeamMembersTable);*/
